import {useMemo} from "react";
import {useLocation} from "react-router-dom";

export const useSearchParams = (): URLSearchParams => {
  const location = useLocation();
  return useMemo<URLSearchParams>(
    () => new URLSearchParams(location.search),
    [location.search]
  );
};
